import React, { createContext, useContext, useState } from 'react';

export type Currency = 'THB' | 'EUR';

const STORAGE_KEY = 'currency';
const DEFAULT_CURRENCY: Currency = 'EUR';

const getInitialCurrency = (): Currency => {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored === 'THB' || stored === 'EUR' ? stored : DEFAULT_CURRENCY;
};

interface CurrencyContextValue {
  currency: Currency;
  setCurrency: (c: Currency) => void;
}

const CurrencyContext = createContext<CurrencyContextValue>({
  currency: DEFAULT_CURRENCY,
  setCurrency: () => {},
});

export const CurrencyProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [currency, setCurrencyState] = useState<Currency>(getInitialCurrency);

  const setCurrency = (c: Currency) => {
    localStorage.setItem(STORAGE_KEY, c);
    setCurrencyState(c);
  };

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);
